import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

export default class Slideshow {
    constructor(el) {
        this.swiper = el.querySelector('.swiper');

        const swiper = new Swiper(this.swiper, {
            modules: [Autoplay, EffectFade],
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            speed: 500,
            effect: 'fade',
            maxBackfaceHiddenSlides: 10
        });
    }
}